import { operators as o } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';

const { VOC } = PRODUCT_AREAS || {};
const { CAPTURE } = SUB_PRODUCT_AREAS || {};

export default {
    name: 'ImportGuidePollResponseSummary',
    productArea: VOC,
    subProductArea: CAPTURE,
    responseFormat: 'rows',
    build ({ guideId, startTime, endTime = 'now()', last90Days = false, onlyCount = false, pollIdToCount = '' }) {
        let timeSeries = {
            period: 'dayRange',
            first: startTime,
            last: endTime,
        };

        if (last90Days) {
            timeSeries = {
                period: 'dayRange',
                first: 'now()',
                count: -90,
            };
        }

        return o.pipeline(
            o.sources.pollEvents({
                guideId,
                timeSeries,
                blacklist: 'apply',
            }),
            o.fork(
                o.pipeline(...(pollIdToCount !== '' ? [o.filter(`pollId == "${pollIdToCount}"`)] : []), o.count(null)),
                ...(onlyCount
                    ? []
                    : [
                        o.pipeline(
                            o.sort('-browserTime'),
                            o.group(['pollId'], o.groupField('pollResponse', { first: 'pollResponse' })),
                            o.select({
                                pollId: 'pollId',
                                pollResponse: 'pollResponse',
                                followUpResponse: 'followUpResponse',
                            }),
                        ),
                    ]),
            ),
        );
    },
};
